import * as tslib_1 from "tslib";
import { VuexModule, Module, Mutation, Action, getModule, } from "vuex-module-decorators";
import store from "@/store";
export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["Mobile"] = 0] = "Mobile";
    DeviceType[DeviceType["Desktop"] = 1] = "Desktop";
})(DeviceType || (DeviceType = {}));
const HOMEPAGE = {
    name: "Home",
    title: "首页",
    params: {},
    path: "/",
    query: {},
};
const getSidebarStatus = () => window.localStorage.getItem("sidebar_status");
const setSidebarStatus = (sidebarStatus) => window.localStorage.setItem("sidebar_status", sidebarStatus);
const getCurrentRoute = () => {
    const current = window.sessionStorage.getItem("current_route") || "";
    if (current)
        return JSON.parse(current);
    else
        return undefined;
};
const setCurrentRoute = (current) => window.sessionStorage.setItem("current_route", JSON.stringify(current));
const getRouteHistory = () => {
    const history = window.sessionStorage.getItem("route_history") || "";
    if (history)
        return JSON.parse(history);
    else
        return undefined;
};
const setRouteHistory = (history) => window.sessionStorage.setItem("route_history", JSON.stringify(history));
let App = class App extends VuexModule {
    constructor() {
        super(...arguments);
        // --------------------State--------------------
        this._sidebar = {
            opened: getSidebarStatus() !== "closed",
            withoutAnimation: false,
        }; // sidebar状态相关
        this._device = DeviceType.Desktop; // 设备类型
        this._current = getCurrentRoute() || HOMEPAGE; // 当前路由记录
        this._history = getRouteHistory() || [HOMEPAGE]; // 路由记录列表
    }
    // --------------------Getters--------------------
    get sidebar() {
        return this._sidebar;
    }
    get device() {
        return this._device;
    }
    get history() {
        return this._history;
    }
    get current() {
        return this._current;
    }
    // --------------------Mutation--------------------
    TOGGLE_SIDEBAR(withoutAnimation) {
        this._sidebar.opened = !this._sidebar.opened;
        this._sidebar.withoutAnimation = withoutAnimation;
        if (this._sidebar.opened) {
            setSidebarStatus("opened");
        }
        else {
            setSidebarStatus("closed");
        }
    }
    CLOSE_SIDEBAR(withoutAnimation) {
        this._sidebar.opened = false;
        this._sidebar.withoutAnimation = withoutAnimation;
        setSidebarStatus("closed");
    }
    TOGGLE_DEVICE(device) {
        this._device = device;
    }
    SET_CURRENT(record) {
        this._current = record;
        setCurrentRoute(this._current);
    }
    PUSH_HISTORY(record) {
        this._history.push(record);
        setRouteHistory(this._history);
        this._current = record;
        setCurrentRoute(this._current);
    }
    REMOVE_RECORD(index) {
        this._history.splice(index, 1);
        setRouteHistory(this._history);
    }
    SET_HISTORY(history) {
        this._history = history;
        setRouteHistory(this._history);
    }
    // --------------------Action--------------------
    ToggleSideBar(withoutAnimation) {
        return withoutAnimation;
    }
    CloseSideBar(withoutAnimation) {
        return withoutAnimation;
    }
    ToggleDevice(device) {
        return device;
    }
    setCurrent(record) {
        return record;
    }
    pushHistory(record) {
        return record;
    }
    removeRecord(index) {
        return index;
    }
    removeLeftRecord(index) {
        return [HOMEPAGE, ...this._history.slice(index)];
    }
    removeRightRecord(index) {
        return this._history.slice(0, index + 1);
    }
    removeOtherRecord(index) {
        if (this._history[index] === HOMEPAGE)
            return [HOMEPAGE];
        else
            return [HOMEPAGE, this._history[index]];
    }
    clearHistory() {
        return [HOMEPAGE];
    }
};
tslib_1.__decorate([
    Mutation // 切换sidebar状态
], App.prototype, "TOGGLE_SIDEBAR", null);
tslib_1.__decorate([
    Mutation // 关闭sidebar
], App.prototype, "CLOSE_SIDEBAR", null);
tslib_1.__decorate([
    Mutation // 设置设备类型
], App.prototype, "TOGGLE_DEVICE", null);
tslib_1.__decorate([
    Mutation // 设置当前路由记录
], App.prototype, "SET_CURRENT", null);
tslib_1.__decorate([
    Mutation // 新增路由记录
], App.prototype, "PUSH_HISTORY", null);
tslib_1.__decorate([
    Mutation // 移除路由记录
], App.prototype, "REMOVE_RECORD", null);
tslib_1.__decorate([
    Mutation // 设置路由历史
], App.prototype, "SET_HISTORY", null);
tslib_1.__decorate([
    Action({ commit: "TOGGLE_SIDEBAR" })
], App.prototype, "ToggleSideBar", null);
tslib_1.__decorate([
    Action({ commit: "CLOSE_SIDEBAR" })
], App.prototype, "CloseSideBar", null);
tslib_1.__decorate([
    Action({ commit: "TOGGLE_DEVICE" })
], App.prototype, "ToggleDevice", null);
tslib_1.__decorate([
    Action({ commit: "SET_CURRENT" })
], App.prototype, "setCurrent", null);
tslib_1.__decorate([
    Action({ commit: "PUSH_HISTORY" })
], App.prototype, "pushHistory", null);
tslib_1.__decorate([
    Action({ commit: "REMOVE_RECORD" })
], App.prototype, "removeRecord", null);
tslib_1.__decorate([
    Action({ commit: "SET_HISTORY" }) // 移除当前路由左侧记录（首页除外）
], App.prototype, "removeLeftRecord", null);
tslib_1.__decorate([
    Action({ commit: "SET_HISTORY" }) // 移除当前路由右侧记录
], App.prototype, "removeRightRecord", null);
tslib_1.__decorate([
    Action({ commit: "SET_HISTORY" }) // 移除当前路由之外其他记录（首页除外）
], App.prototype, "removeOtherRecord", null);
tslib_1.__decorate([
    Action({ commit: "SET_HISTORY" }) // 移除所有路由记录（首页除外）
], App.prototype, "clearHistory", null);
App = tslib_1.__decorate([
    Module({ dynamic: true, store, name: "app" })
], App);
export const AppModule = getModule(App);
